import useSkillStrengthCardState from './useStrengthCardState';
import { useShallow } from 'zustand/react/shallow';

export const useSkillStrengthCardStateActions = () => useSkillStrengthCardState(useShallow(s => ({
  toggleSkillStrengthCard: s.toggleSkillStrengthCard,
})));
